import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import Loadable from 'react-loadable';
import LazyLoad from '@ifeng/ui_pc_lazyLoad';
import Request from './request';
import Wexin from './weixin';
import Wexins from './weixins';
import Welfare from './welfare';
import Wireless from './wireless';
import GoodbookList from './goodbookList';
import Ppx from '../../../components/ppx';

const LoadPPLive = Loadable({
    loader: () => import('./ppLive'),
    loading() {
        return <div />;
    },
});

class RightContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;
        const {
            searchPath,
            article,
            video,
            qrCodeSet,
            welfare,
            wireless,
            goodbook1,
            page_ppposiiton_live1,
            page_ppposiiton_live2,
            articleAd,
            videoAd,
            asideAd1,
            asideAd2,
            asidePPX,
            asideAd3,
            asideAd4,
            asideAd5,
            asideAd6,
        } = content;

        const articleRecommendInfo = {
            id: searchPath.indexOf('2-') === 0 || searchPath.indexOf('4-') === 0 ? '60020' : '30022',
            type: 'recommend',
            title: '热门文章推广位',
            groupName: '侧栏',
            content: article,
            position: 'relative',
            translate: 'handleArticleData',
        };

        const videoRecommendInfo = {
            id: searchPath.indexOf('16-') === 0 ? '60021' : '30023',
            type: 'recommend',
            title: '精彩视频推广位',
            groupName: '侧栏',
            content: video,
            position: 'relative',
            translate: searchPath.indexOf('16-') === 0 ? 'handleFoVideoData' : 'handleVideoData',
        };

        return (
            <div className={styles.rightContent}>
                <Ad content={asideAd1} styleName={styles.asideAd1} />
                <div className={styles.space30} />
                <Request
                    title="热门文章"
                    info={searchPath.indexOf('16-') === 0 ? null : articleRecommendInfo}
                    ad={articleAd}
                    type="article"
                />
                <div className={styles.space40} />
                <Ad content={asideAd2} styleName={styles.asideAd2} />
                <div className={styles.space25} />
                {page_ppposiiton_live1 ? (
                    <LazyLoad>
                        <LoadPPLive title="泡泡直播" tag="page_ppposiiton_live1" content={page_ppposiiton_live1} />
                    </LazyLoad>
                ) : (
                    ''
                )}
                <div className={styles.space25} />
                <Request
                    title={searchPath.indexOf('16-') === 0 ? '精彩推荐' : '精彩视频'}
                    isFo={searchPath.indexOf('16-') === 0}
                    info={videoRecommendInfo}
                    ad={videoAd}
                    type="video"
                />
                <div className={styles.space40} />
                <Ad content={asideAd3} styleName={styles.asideAd3} />
                <div className={styles.space40} />
                {qrCodeSet ? (
                    <Chip
                        id="30004"
                        type="struct"
                        title="微信二维码与微博"
                        groupName="侧栏"
                        position="relative"
                        content={qrCodeSet}>
                        {qrCodeSet instanceof Array ? <Wexins /> : <Wexin />}
                    </Chip>
                ) : (
                    ''
                )}
                <div className={styles.space40} />
                <Chip
                    id="30003"
                    type="struct"
                    title="扫码献爱心"
                    groupName="侧栏"
                    position="relative"
                    content={welfare}>
                    <Welfare />
                </Chip>
                <div className={styles.space40} />
                <Ad content={asideAd4} styleName={styles.asideAd4} />
                <div className={styles.space30} />
                {asidePPX ? (
                    <Chip id="25029" type="static" title="泡泡直播" groupName="头部" user="dev" content={asidePPX}>
                        <Ppx />
                    </Chip>
                ) : (
                    ''
                )}
                <div className={styles.space25} />
                {searchPath.indexOf('16-') === 0 ? '' : <Wireless content={wireless} />}
                <div className={styles.space30} />
                <Ad content={asideAd5} styleName={styles.asideAd5} />
                <div className={styles.space40} />
                <Ad content={asideAd6} styleName={styles.asideAd6} />
                <div className={styles.space25} />
                {page_ppposiiton_live2 ? (
                    <LazyLoad>
                        <LoadPPLive title="泡泡直播" tag="page_ppposiiton_live2" content={page_ppposiiton_live2} />
                    </LazyLoad>
                ) : (
                    ''
                )}
                <div className={styles.space25} />
                {goodbook1 ? (
                    <Chip
                        id="55002"
                        type="recommend"
                        title="侧栏好书精选"
                        groupName="侧栏"
                        position="relative"
                        content={goodbook1}
                        translate="handleGoodbookData">
                        <GoodbookList />
                    </Chip>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(RightContent);
